<template>
  <div class="modal-body">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: "modal-body"
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Modal/ModalBody.vue